import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

declare global {
    interface Window {
        showAppError: (error?: any) => void;
    }
}

if (environment.production) {
    enableProdMode();
}

platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch((err) => {
        if (err) {
            console.error('Application bootstrap failed:', err);

            // Wyświetl statyczną stronę błędu
            if (typeof window.showAppError === 'function') {
                window.showAppError(err);
            }
        }
    });
